// TODO: enforce use of captions

import PropTypes from 'prop-types';
import BsTable from 'react-bootstrap/Table';
import { className } from '../../../utils/GlobalCssProxy';

/**
 * A wrapper around the [react-bootstrap Table component](https://react-bootstrap.github.io/components/table/).
 */
const TableBasic = ({ className: classNameProp, flush, screener, ...props }) => {
  const classes = [
    classNameProp,
    flush ? className.string('table-flush') : undefined,
    screener ? className.string('table-screener') : undefined
  ]
    .filter(Boolean)
    .join(' ');

  return <BsTable className={classes} {...props} />;
};

TableBasic.propTypes = {
  className: PropTypes.string,
  /**
   * Align cell content to the left and right edges of the table
   */
  flush: PropTypes.bool,
  screener: PropTypes.bool
};

TableBasic.defaultProps = {
  flush: false,
  screener: false
};

export default TableBasic;
